import {Box, Button} from "@mui/material"

const ColumnDefs = [
    {
        headerName: "所属",
        field: "office_name",
        rowGroup: true,
        valueGetter: p => {
            if (!p.data) { return null }
            return p.data.office_name ?? "所属未設定"
        },
        hide: true,
    },
    {
        headerName: "名前",
        field: "name",
        rowDrag: true,
    },
    {
        headerName: "メールアドレス",
        field: "email",
    },
    {
        headerName: "認証電話番号",
        field: "phone_number",
        cellRenderer: "phoneRenderer",
    },
    {
        headerName: "オフィス",
        field: "offices",
    },
    {
        headerName: "エリア",
        field: "area_names",
    },
    {
        headerName: "権限",
        children: [
            {
                headerName: "Web管理表",
                cellRenderer: "webPermissionRenderer",
            },
            {
                headerName: "調査アプリ",
                cellRenderer: "appPermissionRenderer"
            },
        ]
    },
    {
        headerName: "有効",
        field: "is_active",
    },
    {
        headerName: "",
        cellRenderer: "controlRenderer",
    }
]

export default ColumnDefs

export const defaultColDef = {

}
